import { useState } from 'react';

import { type MemoryFieldOption } from '@apps/web/lib/memory_inputs';

/** Keeps defaults implicit until the first edit returns an explicit list. */
export function useMemoryInputs(
    options: ReadonlyArray<MemoryFieldOption>,
    storedFields: ReadonlyArray<string> | null,
) {
    const [fields, setFields] = useState<Array<string> | null>(() =>
        storedFields === null ? null : [...storedFields],
    );
    const [edited, setEdited] = useState(false);

    const defaults = options
        .filter((option) => option.default_enabled)
        .map((option) => option.name);
    const enabledFields = fields ?? defaults;
    const onToggle = (name: string, enabled: boolean) => {
        const next = new Set(enabledFields);
        if (enabled) {
            next.add(name);
        } else {
            next.delete(name);
        }
        setFields(
            options
                .filter((option) => next.has(option.name))
                .map((option) => option.name),
        );
        setEdited(true);
    };

    return {
        enabledFields,
        onToggle,
        editedFields: edited ? (fields ?? []) : undefined,
    };
}
